import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { succsesDataChangeAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const CurrentService = () => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const { id } = useParams();

    const { data: service, refetch: refetchService } = useGetPageQuery("services/" + id);
    const [sendForm, { isLoading, isError }] = useSendFormMutation();

    const [name, setName] = useState("");
    const [price, setPrice] = useState("");
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (service) {
            setName(service.title);
            setPrice(service.price);
            setIsActive(service.active);
        }
    }, [service]);

    const sendFormHandler = async () => {
        const formData = {
            title: name,
            price: price,
            active: isActive,
        };

        await sendForm({ body: formData, url: "services/" + id, method: "PUT" }).unwrap();
        await refetchService();

        if (!isError) {
            succsesDataChangeAlert();
            navigate("/services/1");
        }
    };

    return (
        <>
            {service && (
                <div className="content">
                    <div className="col-12">
                        <div id="page-header">
                            <h1>Нова послуга</h1>
                        </div>
                        <div className="form user_form">
                            <input type="hidden" name="id" value="" />
                            <div className="row">
                                <div className="col-12 col-sm-6 col-lg-6">
                                    <div className="card card-default">
                                        <div className="card-header">
                                            Інформація про послугу
                                            <div className="form-check float-end">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={isActive}
                                                    onChange={(e) => setIsActive(e.target.checked)}
                                                />
                                                <label className="form-check-label">Активна</label>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-2">
                                                <label className="form-label">Назва</label>
                                                <input
                                                    className="form-control"
                                                    value={name}
                                                    onChange={(e) => setName(e.target.value)}
                                                    maxLength="255"
                                                    type="text"
                                                />
                                            </div>
                                            <div className="mb-2">
                                                <label className="form-label">Ціна</label>
                                                <input
                                                    className="form-control"
                                                    value={price}
                                                    onChange={(e) => setPrice(e.target.value)}
                                                    maxLength="255"
                                                    type="text"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {permissions.includes("service_edit") || permissions.includes("all") ? (
                                        <div className="saves_block">
                                            <button className="btn btn-labeled btn-primary" onClick={sendFormHandler}>
                                                {isLoading ? "Завантаження" : "Зберегти"}
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="col-12 col-sm-6 col-lg-6"></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default CurrentService;
